<template>
  <b-form-group
    label="Tipo de Projeto"
    :state="state"
    :invalid-feedback="invalidFeedback"
  >
    <multiselect
      label="name"
      track-by="name"
      @input="onChange"
      :loading="loading"
      :options="options"
      :disabled="isDisabled"
      v-model="valorTipoProjeto"
      :class="{
        'is-valid': state === true,
        'is-invalid': state === false,
      }"
      placeholder="Selecione um tipo de projeto"
    >
      <span slot="noOptions">Nenhum Tipo de Projeto disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect from "vue-multiselect";
import { TipoDeProjetoService } from "../../../../../services/astec/tipoDeProjeto";

export default {
  name: "SelectTipoDeProjeto",
  components: { Multiselect },
  props: {
    value: {
      type: Object,
      default: null,
    },
    disabledSelect: {
      type: Boolean,
      default: true,
    },
    state: {
      type: [Boolean, String],
      default: null,
    },
    invalidFeedback: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: [],
      loading: false,
      valorTipoProjeto: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.valorTipoProjeto = newVal;
    },
    valorTipoProjeto(newVal) {
      this.$emit("input", newVal);
    },
  },
  async mounted() {
    await this.carregarTipos();
  },

  computed: {
    isDisabled() {
      return this.disabledSelect;
    },
  },

  methods: {
    async carregarTipos() {
      this.loading = true;
      try {
        this.options = await TipoDeProjetoService.getLkpTipoProjeto();
      } catch (error) {
        console.error("Erro ao carregar tipos de projeto:", error);
      } finally {
        this.loading = false;
      }
    },
    onChange() {
      this.$emit("input", this.valorTipoProjeto);
      this.$emit("change");
      if (this.valorTipoProjeto) {
        this.$emit("selecionado");
      }
    },
  },
};
</script>
